import type {
  ConsentRecord,
  ConsentState,
} from "../types/index";


const STORAGE_KEY = "privacy_consent";


function isBrowser(): boolean {
  return typeof window !== "undefined";
}


export function saveConsent(
  consent: ConsentState,
  policyVersion = "1.0",
  cookiePolicyVersion = "1.0"
): void {

  if (!isBrowser()) {
    return;
  }


  const record: ConsentRecord = {

    consent,

    timestamp: new Date().toISOString(),

    policyVersion,

    cookiePolicyVersion,

  };


  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify(record)
  );

}


export function getConsent(): ConsentRecord | null {

  if (!isBrowser()) {
    return null;
  }


  const saved =
    localStorage.getItem(STORAGE_KEY);


  if (!saved) {
    return null;
  }


  try {

    return JSON.parse(saved) as ConsentRecord;

  } catch {

    localStorage.removeItem(STORAGE_KEY);

    return null;

  }

}


export function clearConsent(): void {

  if (!isBrowser()) {
    return;
  }


  localStorage.removeItem(
    STORAGE_KEY
  );

}